'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { FormControl } from '../Form/FormControl';
import { FormHelperText } from '../Form/FormHelperText';
import { useId } from '../hooks';
import { Input } from '../Input/Input';
import { InputLabel } from '../Input/InputLabel';
export const TextField = forwardRef(({ label, FormControlProps, InputLabelProps, required, fullWidth = true, sx, id = '', name, hiddenLabel, inputRef, inputProps, helperText, onEnter, onKeyPress, error, disabled, ...props }, ref) => {
    const generatedId = useId(id, 'textField');
    // Enable trigger for 'pressing' enter
    const handleKeyPress = (e) => {
        // Run Enter function if available
        if (e.key === 'Enter') {
            if (onEnter && typeof onEnter === 'function') {
                onEnter(e);
            }
        }
        // Run default onKeyPress, if available
        if (onKeyPress && typeof onKeyPress === 'function') {
            onKeyPress(e);
        }
    };
    return (_jsxs(FormControl, { disabled: disabled, fullWidth: fullWidth, required: required, sx: sx, ...FormControlProps, children: [label &&
                _jsx(InputLabel, { ...InputLabelProps, disabled: disabled, hiddenLabel: hiddenLabel, htmlFor: generatedId, children: label }), _jsx(Input, { ...props, disabled: disabled, error: error, fullWidth: true, id: generatedId, inputProps: inputProps, inputRef: inputRef, name: name || generatedId, onKeyPress: handleKeyPress, ref: ref }), helperText && (_jsx(FormHelperText, { disabled: disabled, error: error, children: helperText }))] }));
});
TextField.displayName = 'TextField';
